import {
  Button,
  Flex,
  Icon,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaLock } from "react-icons/fa";

interface Props {
  mensagem?: string | null;
  /** Texto do subtítulo — muda entre "acabei de recusar" e "já estava bloqueado". */
  detalhe?: string;
  /** Quando informado, desconecta sozinho depois desse tempo. */
  autoSairEm?: number;
}

const PADRAO = "Entre em contato com a central para regularização dos termos de aceite";

const DETALHE_PADRAO =
  "O prazo para aceitar os termos venceu ou eles foram recusados. A regularização é feita pela central de atendimento.";

/**
 * Tela de bloqueio do portal: o cliente recusou o termo ou deixou o prazo vencer.
 *
 * Não tem fechar, aceitar nem recusar de propósito — quem regulariza é a central
 * (prorrogar, reabrir, desbloquear ou publicar uma ratificação). O único botão é sair, que
 * não dá acesso a nada.
 *
 * A mensagem vem do servidor para ser idêntica à do 401 do login; o texto abaixo é só
 * defesa para o caso de a API não mandar nada.
 */
export default function BloqueioTermo({ mensagem, detalhe, autoSairEm }: Props) {
  const [restante, setRestante] = useState(autoSairEm ?? 0);

  function sair() {
    window.localStorage.clear();
    window.location.href = "/login";
  }

  // Depois da recusa a sessão já foi encerrada no servidor: a contagem só evita que a
  // tela fique aberta indefinidamente com um token que não vale mais.
  useEffect(() => {
    if (!autoSairEm) return;

    const relogio = setInterval(() => {
      setRestante((s) => {
        if (s <= 1) {
          clearInterval(relogio);
          sair();
          return 0;
        }
        return s - 1;
      });
    }, 1000);

    return () => clearInterval(relogio);
  }, [autoSairEm]);

  return (
    <Modal
      isOpen
      onClose={() => {}}
      closeOnOverlayClick={false}
      closeOnEsc={false}
      isCentered
      size="2xl"
    >
      <ModalOverlay bg="blackAlpha.800" />
      <ModalContent>
        <ModalBody py={12} px={10}>
          <Flex direction="column" align="center" textAlign="center" gap={5}>
            <Icon as={FaLock} boxSize={12} color="red.500" />

            <Text fontSize="xl" fontWeight="bold">
              Acesso bloqueado
            </Text>

            <Text fontSize="md" color="gray.700">
              {mensagem || PADRAO}
            </Text>

            <Text fontSize="sm" color="gray.500">
              {detalhe || DETALHE_PADRAO}
            </Text>

            <Button colorScheme="gray" onClick={sair} mt={2}>
              Sair
            </Button>

            {autoSairEm ? (
              <Text fontSize="xs" color="gray.400">
                Você será desconectado em {restante}s
              </Text>
            ) : null}
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
